export function getDefaultReactRouterStaticHydrationData() {
  return { loaderData: {}, actionData: null, errors: null };
}
